export type ApiRequestContext = {
  location: Location | null;
  prefix: string | null;
  userAgent?: string;
  cookie?: string;
  profileHost?: string | null;
};

type ApiContextRuntime = {
  getStore: () => ApiRequestContext | undefined;
  run: <T>(store: ApiRequestContext, fn: () => T) => T;
};

let runtime: ApiContextRuntime | null = null;

export const setApiContextRuntime = (value: ApiContextRuntime): void => {
  runtime = value;
};

export const runWithApiContext = <T>(
  store: ApiRequestContext,
  fn: () => T
): T => {
  if (!runtime) {
    return fn();
  }
  return runtime.run(store, fn);
};

export const getApiRequestContext = (): ApiRequestContext | undefined =>
  runtime?.getStore();
